import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Menu } from 'edenred-ui';

import { downloadInvoice } from '@epi-actions/api';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { VoucherTypes } from '@epi-constants/voucherTypes';
import { VoucherOrderHistoryActionsProps } from '@epi-models/pages/PaperVouchers';
import { useGetMetadataQuery } from '@epi-api/companyMetadata';

export function VoucherOrderHistoryActions({
  voucherOrder,
  anchorEl,
  closeMenu
}: VoucherOrderHistoryActionsProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: companyMetadata } = useGetMetadataQuery(undefined, {
    refetchOnMountOrArgChange: false
  });

  const downloadVoucherOrderInvoice = () => {
    if (voucherOrder) {
      dispatch(downloadInvoice({ voucherOrderId: voucherOrder.id }));
      closeMenu();
    }
  };

  const goToOrderDetails = () => {
    if (voucherOrder) {
      dispatch(
        goToPage(routerPaths.orderDetails, {
          params: {
            voucherType: VoucherTypes[voucherOrder.voucherType],
            voucherOrderId: voucherOrder.id
          }
        })
      );
      closeMenu();
    }
  };

  const goToVoucherReorder = () => {
    if (voucherOrder) {
      dispatch(
        goToPage(routerPaths.voucherReorder, {
          params: {
            voucherType: VoucherTypes[voucherOrder.voucherType],
            orderId: voucherOrder.id
          }
        })
      );
      closeMenu();
    }
  };

  return (
    <Menu
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={closeMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
    >
      <Menu.Item
        onClick={downloadVoucherOrderInvoice}
        id="order-history_download"
      >
        {t('paper_vouchers.order_history.action_download')}
      </Menu.Item>
      <Menu.Item onClick={goToOrderDetails} id="order-history_details">
        {t('paper_vouchers.order_history.action_details')}
      </Menu.Item>
      {companyMetadata?.orderVouchersEnabled && (
        <Menu.Item onClick={goToVoucherReorder} id="order-history_reorder">
          {t('paper_vouchers.order_history.action_reorder')}
        </Menu.Item>
      )}
    </Menu>
  );
}
